import { useState, useRef } from "react";
import { ChevronLeft, ChevronRight, MessageCircle, X } from "lucide-react";

const BACKEND = "";

const chatScreenshots = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/i87jcb5l_Screenshot_20260320_222256_Telegram.jpg",
    platform: "Telegram",
    summary: "Класс! Отлично! Спасибо! Все понравилось)",
    date: "16 марта",
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/xbd3j8pg_Screenshot_20260320_222528_Telegram.jpg",
    platform: "Telegram",
    summary: "Thank you! So beautiful. She will definitely like it",
    date: "7 марта",
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/bnrnk1lq_Screenshot_20260320_222809_Telegram.jpg",
    platform: "Telegram",
    summary: "Доброе утро, спасибо!",
    date: "5 января",
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/vbbeuo7w_Screenshot_20260320_222915_Telegram.jpg",
    platform: "Telegram",
    summary: "Спасибо!",
    date: "16 декабря",
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/hq4d7i3j_Screenshot_20260320_221549_WhatsAppBusiness.jpg",
    platform: "WhatsApp",
    summary: "Очень красивый букет! Благодарю.",
    date: "",
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/aw2vq8co_Screenshot_20260320_221956_WhatsAppBusiness.jpg",
    platform: "WhatsApp",
    summary: "Спасибо! Букет доставлен вовремя",
    date: "",
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/f7a98py3_Screenshot_20260320_221132_WhatsAppBusiness.jpg",
    platform: "WhatsApp",
    summary: "Ок, спасибо! Букет доставлен",
    date: "",
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/i25poph1_Screenshot_20260320_220914_WhatsAppBusiness.jpg",
    platform: "WhatsApp",
    summary: "Благодарю всей душой!",
    date: "",
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/nm9ls4ag_IMG_1523.JPG",
    platform: "Instagram",
    summary: "@feridedupont — yuccainc flowers",
    date: "",
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_84b36567-5019-4fda-82e6-db8743004f9f/artifacts/5trzmuk1_IMG_1524.JPG",
    platform: "Instagram",
    summary: "@prive_beauty_club — букет от @yuccainc",
    date: "",
  },
];

const ReviewCard = ({ review, onClick }) => {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  if (errored) return null;

  return (
    <div
      className="flex-shrink-0 w-[260px] sm:w-[300px] cursor-pointer group"
      onClick={() => onClick(review)}
      data-testid={`review-card-${review.id}`}
    >
      <div className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-100">
        {!loaded && (
          <div className="aspect-[9/16] bg-gradient-to-b from-gray-100 to-gray-200 animate-pulse" />
        )}
        <img
          src={review.image}
          alt={`Отзыв клиента — ${review.platform}`}
          className={`w-full aspect-[9/16] object-cover object-top transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0 absolute inset-0"}`}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
        />
        {/* Platform badge */}
        <div className="absolute top-3 left-3">
          <span className={`text-xs font-bold px-3 py-1 rounded-full text-white shadow-lg ${
            review.platform === "WhatsApp" ? "bg-[#25d366]" : review.platform === "Instagram" ? "bg-gradient-to-r from-purple-500 via-pink-500 to-orange-400" : "bg-[#0088cc]"
          }`}>
            {review.platform}
          </span>
        </div>
      </div>
    </div>
  );
};

const ImageModal = ({ review, onClose, lang }) => {
  if (!review) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
      data-testid="review-modal-overlay"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors"
        data-testid="review-modal-close"
      >
        <X className="w-5 h-5 text-white" />
      </button>
      <img
        src={review.image}
        alt={`${lang === "tr" ? "Musteri yorumu" : lang === "en" ? "Customer review" : "Отзыв клиента"} — ${review.platform}`}
        className="max-h-[85vh] max-w-[90vw] object-contain rounded-2xl shadow-2xl animate-scale-in"
        onClick={(e) => e.stopPropagation()}
        data-testid="review-modal-image"
      />
    </div>
  );
};

export const ReviewsSection = ({ lang = "ru", t, id = "reviews" }) => {
  const scrollRef = useRef(null);
  const [modalReview, setModalReview] = useState(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section id={id} className="py-16 sm:py-24 bg-gradient-to-b from-pink-50 to-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14 px-4 sm:px-6">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-rose-500 px-4 py-1.5 rounded-full mb-4">
            <MessageCircle className="w-4 h-4 text-white" />
            <span className="text-sm font-semibold text-white">{t ? t("rev.badge") : "Реальные переписки"}</span>
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            {t ? t("rev.title") : "Отзывы"}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-500">{t ? t("rev.titleAccent") : "клиентов"}</span>
          </h2>
          <p className="text-gray-500 max-w-md mx-auto text-base sm:text-lg">
            {t ? t("rev.subtitle") : "Скриншоты реальных переписок с нашими клиентами"}
          </p>
        </div>

        {/* Carousel */}
        <div className="relative">
          {/* Arrows */}
          <button
            onClick={() => scroll("left")}
            className="hidden sm:flex absolute left-2 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full bg-white shadow-lg items-center justify-center hover:bg-gray-50 transition-colors border border-gray-100"
            data-testid="reviews-scroll-left"
            aria-label={lang === "en" ? "Previous reviews" : lang === "tr" ? "Önceki yorumlar" : "Предыдущие отзывы"}
          >
            <ChevronLeft className="w-5 h-5 text-gray-700" />
          </button>
          <button
            onClick={() => scroll("right")}
            className="hidden sm:flex absolute right-2 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full bg-white shadow-lg items-center justify-center hover:bg-gray-50 transition-colors border border-gray-100"
            data-testid="reviews-scroll-right"
            aria-label={lang === "en" ? "Next reviews" : lang === "tr" ? "Sonraki yorumlar" : "Следующие отзывы"}
          >
            <ChevronRight className="w-5 h-5 text-gray-700" />
          </button>

          {/* Scrollable row */}
          <div
            ref={scrollRef}
            className="flex gap-4 sm:gap-5 overflow-x-auto px-4 sm:px-14 pb-4 scrollbar-hide snap-x snap-mandatory"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {chatScreenshots.map((review) => (
              <ReviewCard key={review.id} review={review} onClick={setModalReview} />
            ))}
          </div>
        </div>
      </div>

      {/* Fullscreen modal */}
      {modalReview && <ImageModal review={modalReview} onClose={() => setModalReview(null)} lang={lang} />}
    </section>
  );
};

export default ReviewsSection;
